<template>
	<span @click.stop>
		<slot name="clickTarget">
			<TooltipButton
				@click="copyToClipboard"
				:tooltipText="`Copy ${valueName} to clipboard`"
				:icon="true"
				:disabled="disabled"
				:size="size"
			>
				<template #btnContent>
					<Copy16 v-if="!showCopyNotification" />
					<CheckmarkFilled16
						v-else
						class="sgnl-icon-color-success"
					/>
				</template>
			</TooltipButton>
		</slot>
		<v-snackbar
			v-model="showCopyNotification"
			class="snackbar-success"
		>
			<div class="snackbar-icon-container snackbar-success">
				<CheckmarkFilled16 />
			</div>
			Copied {{ valueName }} to clipboard!
		</v-snackbar>
	</span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Carbon Icons
import Copy16 from "@carbon/icons-vue/es/copy/16";
import CheckmarkFilled16 from "@carbon/icons-vue/es/checkmark--filled/16";

// Components
import TooltipButton from "@/components/Common/TooltipButton.vue";

export default defineComponent({
	name: "CopyToClipboardButton",
	components: { TooltipButton, Copy16, CheckmarkFilled16 },
	props: {
		valueToCopy: {
			type: String,
			default: "",
		},
		valueName: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: [String, Number],
			default: undefined,
		},
	},
	emits: {
		copied: () => true,
	},
	data: (): { showCopyNotification: boolean } => ({
		showCopyNotification: false,
	}),

	methods: {
		copyToClipboard() {
			if (this.valueToCopy) {
				navigator.clipboard.writeText(this.valueToCopy);
				this.showCopyNotification = true;
				this.$emit("copied");
			}
		},
	},
});
</script>
